export default {
  data() {
    return {}
  },

  methods: {
    async fetchPOBRTemplateId() {
      try {
        const fetchPOBRTemplateIdResponse = await this.$http.get('/template');
        return fetchPOBRTemplateIdResponse.data.id;
      } catch (e) {
        return await this.handleError(e, this.fetchPOBRTemplateId.bind(this));
      }
    },
    async fetchPOBRClient() {
      try {
        const fetchPOBRClientResponse = await this.$http.get('/client');

        if (fetchPOBRClientResponse.data.birthDate) {
          fetchPOBRClientResponse.data.birthDate = new Date(fetchPOBRClientResponse.data.birthDate);
        }

        return fetchPOBRClientResponse.data;
      } catch (e) {
        return await this.handleError(e, this.fetchPOBRClient.bind(this));
      }
    },
    async fetchPOBRClientContacts() {
      try {
        const fetchPOBRClientContactsResponse = await this.$http.get('/client/contacts');

        return fetchPOBRClientContactsResponse.data;
      } catch (e) {
        return await this.handleError(e, this.fetchPOBRClientContacts.bind(this));
      }
    },
    async attemptPOBRContactVerification(ccId) {
      try {
        const attemptContactVerificationResponse = await this.$http.post('/pobr/contact/attempt-verification', {ccId});

        return attemptContactVerificationResponse.data;
      } catch (e) {
        return await this.handleError(e, this.attemptPOBRContactVerification.bind(this, ...arguments));
      }
    }
  }
}
